import { createContext } from "react";

export const BoosterContext = createContext({
  isBoosterApplyRunning: "",
  updateIsBoosterApplyRunning: () => {},
  updateBoosterApplyFalse: () => {},
});
